import loginPage from "./loginPage"
export default loginPage;
